export default __webpack_public_path__ + "static/media/pantry2-after2-1920w.9342d18d.png";